import { render } from "./House.vue?vue&type=template&id=14320ca0"
import script from "./House.vue?vue&type=script&lang=js"
export * from "./House.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gimmetm/work/projects/tnms-go/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__